module.exports = __webpack_public_path__ + "img/mark1.ae0a3762.png";